import { render, staticRenderFns } from "./AHCuratedSearchItemDetail.vue?vue&type=template&id=041e9f7b&"
import script from "./AHCuratedSearchItemDetail.vue?vue&type=script&lang=ts&"
export * from "./AHCuratedSearchItemDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports